import React from 'react';
import { Button, Text } from '@fluentui/react-components';

export interface PoliciesPaginationFooterProps {
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  hasNextPage: boolean;
  loading: boolean;
  /**
   * Accepts the same signature as React's `setState` setter so the footer can
   * use functional updates and avoid stale-state regressions on rapid clicks.
   */
  onPageChange: React.Dispatch<React.SetStateAction<number>>;
}

/**
 * Pagination footer shared by DashboardPoliciesTable and TenantPoliciesTable.
 * Renders nothing when `totalPages <= 1`.
 */
export const PoliciesPaginationFooter: React.FC<PoliciesPaginationFooterProps> = ({
  pageNumber,
  totalPages,
  pageSize,
  hasNextPage,
  loading,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '12px',
        padding: '8px 12px',
      }}
    >
      <Button
        appearance="secondary"
        disabled={pageNumber <= 1 || loading}
        onClick={() => onPageChange((p) => Math.max(1, p - 1))}
      >
        Previous
      </Button>
      <Text>
        Page {pageNumber} of {totalPages}
      </Text>
      <Button
        appearance="secondary"
        disabled={!hasNextPage || loading}
        onClick={() => onPageChange((p) => p + 1)}
      >
        Next
      </Button>
      <Text size={200}>{pageSize} per page</Text>
    </div>
  );
};
